/* Signup Controller
** Author: soc-dfsk-30
** Version: 1.0
** Date 10/01/2017 */
'use strict';
App.controller('SignupCtrl', ['$rootScope', '$scope', '$http', '$cookies', '$cookieStore', 'ngDialog', '$timeout', 
    'toastr', 'Api', '$state', 'authApi', '$localStorage', '$sessionStorage',
    '$loading', 'mixPanelApi', 'ProfessionalService', 'UsersClientService', 'LicenseService', 'SpecialtyService',
    function ($rootScope, $scope, $http, $cookies, $cookieStore, ngDialog, $timeout, toastr,
              Api, $state, authApi, $localStorage, $sessionStorage, $loading, mixPanelApi, ProfessionalService,
              UsersClientService, LicenseService, SpecialtyService) {
        $scope.user = {
            license: '',
            specialties: []
        };
        $scope.professions = ['Nurse', 'Allied Health'];
        $scope.licenses = [];
        $scope.specialties = [];
        $scope.selectedLicenses = [];
        $scope.selectedSpecialties = ['None'];
        $scope.formSubmitted = false;
        let dialogId;

        // load licenses and specialties
        this.loadBriefcaseConstants = async function() {
            LicenseService.list(undefined)
                .then(licenses => {
                    $scope.licenses = licenses;
                    $scope.$applyAsync();
                })
                .catch(e => console.error(e))
            SpecialtyService.list(undefined)
                .then(specialties => {
                    $scope.specialties = specialties;
                    $scope.$applyAsync();
                })
                .catch(e => console.error(e))
        }

        this.$onInit = async function () {
            this.loadBriefcaseConstants();
        }

        $scope.professionUpdated = function(profession) {
            if (profession) {
                $scope.selectedLicenses = $scope.licenses.filter(license => license.profession === profession);
                $scope.selectedSpecialties = ['None'].concat($scope.specialties.filter(specialty => specialty.profession === profession).map(specialty => specialty.name));
            }
            $scope.user.license = '';
            $scope.user.specialties = profession === 'Allied Health'? ['None'] : [];
        }

        $scope.signupUser = async function (valid) {
            if (!valid || $scope.formSubmitted || !$scope.user.specialties.length) {
                return;
            }

            $scope.formSubmitted = true;
            $loading.start('prnSignUp');
            const {firstName, lastName, email, profession, password, phoneNumber, specialties, license } = $scope.user;
            const payload = {
                item: {
                    firstName, 
                    lastName, 
                    email, 
                    profession, 
                    phoneNumber, 
                    briefcase: {
                        licenses: [{ licenseType: license, isCompact: false }],
                        specialties: specialties.includes('None') ? undefined : specialties
                    }
                }, 
                password };
            try {
                await ProfessionalService.add(payload);
                $scope.signup_message = 'Your email address has been registered. A verification email has been sent to your email account. Please click on the link to verify your address and continue to complete your application.';
                $timeout(function () {
                    dialogId = ngDialog.open({
                        template: 'register-popup',
                        className: 'ngdialog-theme-default register-popup',
                        closeByNavigation: true,
                        showClose: false,
                        scope: $scope
                    });
                    $scope.formSubmitted = false;
                    $loading.finish('prnSignUp');
                }, 100);
            } catch (e) {
                $scope.exist_message = e.message;
                $scope.formSubmitted = false;
                $loading.finish('prnSignUp');
                $scope.dialogId = ngDialog.open({
                    template: 'email_exists',
                    className: 'ngdialog-theme-default register-popup',
                    closeByNavigation: true,
                    showClose: false,
                    scope: $scope
                });
                $scope.dialogHandler = () => {
                    ngDialog.close(dialogId);
                    window.location.hash = '/login';
                    window.location.reload();
                }
            }
        }

        $scope.resendLink = async function (e) {
            e.preventDefault();
            try {
                await UsersClientService.resendVerification({ email: $scope.user.email });
                ngDialog.close($scope.dialogId);
                toastr.success('A verification link has been sent to your email address. Please check your email address.');
            }catch (e){
                toastr.error(e.message);
            }
        }

        /* close banner popup function */
        $scope.closeBanner = function () {
            $scope.bannerClose = true;
        };
        
        $scope.closePopup = function () {
            ngDialog.closeAll();
            $state.go('login');
        }
    }]);
